import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { message } from 'antd';
import routes from '../../../router/routes';
import ContentHeader from '../../../components/ContentHeader';
import DictionaryForm from '../../../containers/shared/DictionaryForm';
import { useCreateLanguageMutation } from '../../../store/apis/dictionaries/languages';

const Create = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [createLanguage, { isFetching: isCreateLanguageFetching, isLoading }] = useCreateLanguageMutation();

  const handleSubmit = useCallback(async (values) => {
    try {
      await createLanguage({ body: values }).unwrap();
      message.success(t('Язык создан'));
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [createLanguage, t]);

  const handleExit = useCallback(() => {
    navigate(routes.languages());
  }, [navigate]);

  return (
    <div>
      <ContentHeader title={t('Создать новый язык')} />
      <DictionaryForm
        onSubmit={handleSubmit}
        onExit={handleExit}
        initialValues={{}}
        loading={isCreateLanguageFetching || isLoading}
        saveTitle={t('Сохранить и создать еще')}
        saveAndExitTitle={t('Сохранить и выйти')}
      />
    </div>
  );
};

export default Create;
